import React from 'react';
import '../App.css'
import logo from '../img/pantheon-logo-white.svg'
import linkedin from '../img/linkedin.png'
import twitter from '../img/twitter.png'
import { Link as RouterLink } from 'react-router-dom';
import {  List, ListItem, Typography,  Link, Container, Grid } from '@material-ui/core';
import {  ThemeProvider  } from '@material-ui/styles';
import theme from '../theme';
import globalUseStyles from '../styleHooks';


function Footer() {
  const globalClasses = globalUseStyles();
  return (
<ThemeProvider theme={theme}>
   <Container className={"footerStyle"} maxWidth={false} component="section">
      <Grid className={globalClasses.footerContainer} container >
         <Grid className={globalClasses.containerSmall} container >
            <Grid className={globalClasses.cardStyleLeft} item md={12} lg={3} >
               <Link href={'/'}>
               <img src={logo} alt="logo"/></Link>
               <Typography variant="body2">2500 Wilson Blvd., Suite 200</Typography>
               <Typography variant="body2">Arlington, VA 22201</Typography>
            </Grid>
            <Grid className={globalClasses.cardStyleRight} item md={12} lg={9} container >
               <Grid item xs={12}>
                  <ul className={globalClasses.footerNavUl}>
                     <li className={globalClasses.footerSocialList}><a href="https://www.linkedin.com"><img src={linkedin} alt="linkedin"/></a></li>
                     <li className={globalClasses.footerSocialList}><a href="https://www.twitter.com"><img src={twitter} alt="twitter"/></a></li>
                  </ul>
               </Grid>
               <Grid item xs={12}>
                  <List className={globalClasses.footerList}>
                     <ListItem className={globalClasses.footerListItem} >
                        <Link to='/solutions' className={globalClasses.footerLinkText}  component={RouterLink}>
                        Our Services and Solutions</Link>
                     </ListItem>
                     <ListItem className={globalClasses.footerListItem}>
                        <Link to='/work' className={globalClasses.footerLinkText}  component={RouterLink}>
                        Our Work</Link>
                     </ListItem>
                     <ListItem className={globalClasses.footerListItem}>
                        <Link to='/government' className={globalClasses.footerLinkText}  component={RouterLink}>
                        Government Services</Link>
                     </ListItem>
                     <ListItem className={globalClasses.footerListItem}>
                        <Link to='/who' className={globalClasses.footerLinkText}  component={RouterLink}>
                        Who We Are</Link>
                     </ListItem>
                     <ListItem className={globalClasses.footerListItem}>
                        <Link to='/careers' className={globalClasses.footerLinkText}  component={RouterLink}>
                        Careers</Link>
                     </ListItem>
                  </List>
               </Grid>
               <Grid item xs={12} className={globalClasses.footerSeparator}>
                  <List className={globalClasses.footerList}>
                     <ListItem className={globalClasses.footerListItem}>
                        <Link to='/support' className={globalClasses.footerLinkText}  component={RouterLink}>
                        Support</Link>
                     </ListItem>
                     <ListItem className={globalClasses.footerListItem}>
                        <Link to='/contact' className={globalClasses.footerLinkText}  component={RouterLink}>
                        Contact Us</Link>
                     </ListItem>
                  </List>
               </Grid>
            </Grid>
            <Grid item xs={false} md={1} />
         </Grid>
      </Grid>
   </Container>
</ThemeProvider>
  );
};

export default Footer;